export const common = {
  ok: "OK",
  yes: "はい",
  no: "いいえ",
  cancel: "キャンセル",
  save: "保存",
  delete: "削除",
  edit: "編集",
  close: "閉じる",
  back: "戻る",
  next: "次へ",
  confirm: "確認",
  send: "送信",
  loading: "読み込み中...",
  processing: "処理中...",
  error: "エラーが発生しました",
  unexpectedErrorMessage:
    "このユーザーは表示できません\nページを更新してください",
  cannotDisplayContent:
    "この情報を表示できません\n時間をおいてから再度お試しください",
  retry: "再試行",
  noData: "データがありません",
  search: "検索",
  menu: "メニュー",
  secondsAgo: (args: { count: string | number }) => `${args.count}秒前`,
  minutesAgo: (args: { count: string | number }) => `${args.count}分前`,
  hoursAgo: (args: { count: string | number }) => `${args.count}時間前`,
  daysAgo: (args: { count: string | number }) => `${args.count}日前`,
  videoAvailable: "利用可能",
  onlineNow: "オンライン中",
  recentlyOnline: "最近オンライン",
  offline: "オフライン",
  onlineStatus: "オンラインステータス",
  newUser: "新人",
  lovenseBadge: "遠隔バイブ対応",
  videoCallWaiting: "ビデオ通話可",
  voiceCallWaiting: "音声通話可",
  insufficientPoint: {
    title: "ポイント不足",
    description: (args: { actionName: string | number }) =>
      `ポイントが不足しているため、${args.actionName}を行えませんでした。\nポイント購入後に再度お試しください。`,
    purchaseButton: "ポイントを購入する",
  },
  pullToRefresh: {
    refreshing: "更新中...",
    release: "離して更新",
    pull: "引っ張って更新",
  },
} as const;
